import React from "react";
import Lottie from "react-lottie";
import styled from "styled-components";
import { isMobile } from "react-device-detect";

import * as animationData from "../animations/animation2.json";

const LottieWrapper = styled.div`
  position: relative;
  z-index: 0;
  margin: 10rem 0;
  filter: sepia(1) drop-shadow(2px 4px 6px black);
`;

class LottieControl extends React.Component {
  UNSAFE_componentWillMount() {
    this.setState({}, (_) => this.setSpeed());
    this.setState({}, (_) => this.setSegments());
  }
  setSpeed() {
    this.setState({ speed: 5 });
  }
  setSegments() {
    this.setState({ segments: 0 });
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,

      animationData: animationData.default,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <>
        <Lottie
          options={defaultOptions}
          height={isMobile ? 100 : 100}
          width={isMobile ? 100 : 100}
          speed={0.9}
          isClickToPauseDisabled={true}
        />
        {this.props.children}
      </>
    );
  }
}

export default function LottieAnimation6() {
  return (
    <LottieWrapper>
      <LottieControl />
    </LottieWrapper>
  );
}
